import { DocumentPanel } from '../../components/panels/DocumentPanel';
import type { DocPanel } from '../../lib/types';

const DOC: DocPanel = {
  title: 'Presentation',
  file: 'TAPIS DEEP-1RDR1_PRESENTATION_20260911.pdf',
  page: 1,
  pageCount: 1,
  kind: 'geology',
};

const META = ['TAPIS DEEP-1RDR1', 'NAGA-2', 'COB', 'PM515', '11-09-2026'];

const SECTIONS = [
  {
    heading: 'LAST 24 HOURS OPERATION',
    body: 'POOH & L/D WL Run #3: MDT (QS-Saturn) toolstring. R/D WL equipment. C/O saver sub. Retrieved WB & Bore Protector. Jetted clean WH, BOP & RCD Housing. Performed full BOP test.',
  },
  { heading: 'CURRENT OPERATION @ 0600 HRS', body: 'Performing full BOP test.' },
  {
    heading: 'NEXT 24 HOURS OPERATION',
    body: 'Cont. to perform full BOP test. Perform RCD test. Displ. BOP to 19.4 ppg SBM. Set WB & Bore Protector. M/U & RIH 12-1/4" x 14" UR BHA.',
  },
  { heading: 'Remarks', body: '' },
];

/** Casing string drawn beside the report, as the presentation sheet shows it. */
const STRINGS = [
  { label: '30" Conductor', top: 0, bottom: 34, fill: '#3a7bd5' },
  { label: '20" Casing', top: 34, bottom: 60, fill: '#8ec5e8' },
  { label: '13-3/8" Casing', top: 60, bottom: 82, fill: '#cfe3f5' },
];

export function Presentation() {
  return (
    <DocumentPanel doc={DOC} onPrev={() => undefined} onNext={() => undefined} full>
      <article className="paper paper--wide" aria-label="Operation update">
        <div className="presentation">
          <div className="pres-report">
            <header className="pres-band">
              <span>OPERATION UPDATE (0600 - 0600 HRS)</span>
              {META.map((m) => (
                <b key={m}>{m}</b>
              ))}
            </header>

            {SECTIONS.map((s) => (
              <section className="pres-section" key={s.heading}>
                <h3>{s.heading}</h3>
                <p>{s.body}</p>
              </section>
            ))}
          </div>

          <div className="pres-diagram">
            <div className="pres-diagram-head">
              <span>SUBJECT</span>
              <span>DEPTH (m) MDDF TVDSS</span>
              <span>WELL DIAGRAM</span>
              <span>DEPTH (m) MDDF TVDSS</span>
              <span>SUBJECT</span>
            </div>

            <div className="pres-diagram-body">
              <div className="pres-col pres-col--labels">
                <span>Seabed</span>
                <em>95.0 m MD</em>
                <em>65.0 m TVDSS</em>
              </div>

              <div className="pres-col pres-col--plan">
                {STRINGS.map((s) => (
                  <span
                    key={s.label}
                    className="pres-string"
                    style={{ top: `${s.top}%`, height: `${s.bottom - s.top}%`, background: s.fill }}
                    title={s.label}
                  />
                ))}
              </div>

              <div className="pres-col pres-col--actual">
                {STRINGS.map((s) => (
                  <span
                    key={s.label}
                    className="pres-string"
                    style={{
                      top: `${s.top + 3}%`,
                      height: `${s.bottom - s.top}%`,
                      background: s.fill,
                      opacity: 0.75,
                    }}
                    title={s.label}
                  />
                ))}
              </div>

              <div className="pres-col pres-col--labels">
                <span>Seabed</span>
                <em>96.5 m MD</em>
                <em>64.8 m TVDSS</em>
              </div>
            </div>
          </div>
        </div>
      </article>
    </DocumentPanel>
  );
}
